module.exports = {
  "country": "SE",
  "artist": "ABBA",
  "song": "Waterloo",
  "year": "1974",
  "place": "1",
  "spotify": "3Dy4REq8O09IlgiwuHQ3sk"
};